export default {
  init() {},
  finalize() {
    $(".post-showcase__slides").slick({
      prevArrow:
        '<a href="#" class="post-showcase__arrow post-showcase__arrow-left"><i class="fa-regular fa-arrow-left"></i></a>',
      nextArrow:
        '<a href="#" class="post-showcase__arrow post-showcase__arrow-right"><i class="fa-regular fa-arrow-right"></i></a>',
      fade: true,
      dots: true,
      dotsClass: "slide__dots",
    });
  },
};
